import funcTranslateHelper from '../../../i18next/funcTranslateHelper';

export const schema = {
  type: 'object',
  required: ['username', 'name', 'email', 'phoneNumber', 'role'],
  properties: {
    username: {
      title: 'ID',
      type: 'string',
      placeholder: 'usernamePlaceholder',
      readOnly: false
    },
    name: {
      title: 'name',
      type: 'string',
      placeholder: 'namePlaceholder',
      readOnly: false
    },
    email: {
      title: 'email',
      type: 'string',
      placeholder: 'emailPlaceholder',
      readOnly: false
    },
    phoneNumber: {
      title: 'phoneNumber',
      type: 'string',
      placeholder: 'phoneNumberPlaceholder',
      readOnly: false
    },
    role: {
      title: 'role',
      type: 'string',
      enum: [],
      enumNames: [],
      default: ''
    },
    onlyOwn: {
      title: 'onlyOwn',
      type: 'string',
      enum: [
        '',
        'true',
        'false'
      ],
      enumNames: [
        'chooseOption',
        'true',
        'false'
      ],
      default: ''
    },
    id: {
      type: 'string'
    }
  }
};

export const uiSchema = {
  'ui:rootFieldId': 'form-roles',
  username: {
    'ui:field': 'TextInput',
    classNames: 'form-control-parent'
  },
  name: {
    'ui:field': 'TextInput',
    classNames: 'form-control-parent'
  },
  email: {
    'ui:field': 'TextInput',
    classNames: 'form-control-parent',
    'ui:options': 'email'
  },
  phoneNumber: {
    'ui:field': 'TextInput',
    classNames: 'form-control-parent'
  },
  role: {
    'ui:field': 'Select',
    classNames: 'form-control-parent'
  },
  onlyOwn: {
    'ui:field': 'Select',
    classNames: 'form-control-parent'
  },
  id: {
    'ui:field': 'HiddenId'
  }
};

export const translateSchema = (inputSchema) => {
  function translateProperties (inputProperties) {
    const outputProperties = inputProperties;
    const keys = Object.keys(inputProperties);
    for (let i = 0; i < keys.length; i++) {
      if (inputProperties[keys[i]].title) outputProperties[keys[i]].title = funcTranslateHelper(`Builder:Users:form:${inputProperties[keys[i]].title}`);
      if (inputProperties[keys[i]].placeholder) outputProperties[keys[i]].placeholder = funcTranslateHelper(`Builder:Users:form:${inputProperties[keys[i]].placeholder}`);
      if (inputProperties[keys[i]].enumNames) outputProperties[keys[i]].enumNames = outputProperties[keys[i]].enumNames.map(element => funcTranslateHelper(`Builder:Users:form:${element}`));
    }

    return outputProperties;
  }

  inputSchema.properties = translateProperties(inputSchema.properties);
}
;
